import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges } from '@angular/core';
import { AppConfigurationService } from '@projects/shared/src/app/services/app.configuration.service';
import { AgentCallEvaluationService } from '../agent-call-evaluation.service';
import { CxTableService } from '@projects/shared/src/app/modules/cx-datagrid/services/cx-table.service';
import { AuthenticationService } from '@app/core';
import { formatDate } from '@projects/shared/src/app/utils';
import moment from 'moment';
import { EvaluationFormStatus } from '../agent-call-evaluation-response';
import { RefreshEvaluationListService } from '../refresh-evaluation-list.service';
import { HttpClient } from '@angular/common/http';
import { ToastService } from '@projects/shared/src/app/services/toast/toast.service';
import { CheckPermission } from '@projects/shared/src/app/utils/helper';

@Component({
    selector: 'agent-call-evaluation-form',
    templateUrl: './agent-call-evaluation-form.component.html',
    styleUrls: ['./agent-call-evaluation-form.component.scss']
})
export class AgentCallEvaluationFormComponent implements OnInit, OnChanges, OnDestroy {
    @Output() close = new EventEmitter();
    @Input() isViewMode: boolean = false;
    @Input() isDisputed: boolean = false;
    @Input() status: string = '';

    @Input() disableActions: boolean = true;
    data: any;
    isSectionExpanded: boolean = false;
    isSupervisor: boolean = false;
    isAgent: boolean = false;
    showCoach: boolean = false;
    sections: any[] = [];
    totalPossiblePoints: any = 0;
    totalScoredPoints: any = 0;
    totalOverallScoredPoints: any = 0;
    overaAllPerc: any = 0;
    bonusPoints: Number = 0;
    isCallbackRequired: boolean = false;
    callBackComment: string = "";
    disputeComments: string = "";
    evaluatorComment: string = "";
    isFileUploaded: boolean = false;
    isSavedRecord: boolean = false;
    selectedFile: File | null = null;
    fileName: string = '';
    isUploading: boolean = false;
    isDownloading: boolean = false;
    allowDownload: boolean = false;

    agentInformation: any = {
        agent: '',
        supervisor: '',
        location: '',
        client: '',
        campaign: ''
    };
    callInformation: any = {
        callID: '',
        monitoringDate: '',
        callDate: '',
        callTime: '',
        wrapTime: 0,
        holdTime: 0,
        callDuration: '',
        tfn: '',
        callType: '',
        disposition: 'N/A'
    };
    maxCharacters: number = 274;
    checkPermission = CheckPermission;

    constructor(
        public appConfig: AppConfigurationService,
        public service: AgentCallEvaluationService,
        public cxtableService: CxTableService,
        public authService: AuthenticationService,
        private refreshService: RefreshEvaluationListService,
        private toastService: ToastService,
        private http: HttpClient) { }

    ngOnChanges(changes: SimpleChanges): void { }

    toggleSection() {
        this.isSectionExpanded = !this.isSectionExpanded;
    }

    ngOnInit(): void {
        const row = this.cxtableService.editColumn.row;
        this.allowDownload = CheckPermission('quality_evaluation_list_allow_download_sup', '', this.authService);
        if (('IsEvaluated' in row && !row?.IsEvaluated) || 'SendForApproval' in row && !row?.SendForApproval) {
            this.isViewMode = false;
            this.isSavedRecord = 'SendForApproval' in row ? !row.SendForApproval : false;
        } else if ('Status' in row) {
            if (row?.Status === 'Disputed') { // when QA evalaution disputed by supervisor
                this.isDisputed = true;
                this.isViewMode = true;
            }
            else if ('Disputed' in row && row?.Disputed)
                this.showCoach = true;
            else
                this.status = row.Status;
        }
        this.init();
    }

    init() {
        if (this.isViewMode)
            this.getApprovedQuestionList(this.cxtableService.editColumn?.row.CallSid);
        else 
            this.getQuestionsList();

        this.fillAgentAndCallDetails(this.cxtableService.editColumn?.row);
    }

    getQuestionsList = (): void => {
        this.service.getQuestions().subscribe((data: any) => {
            this.sections = data.map((section: any) => {
                section.Questions = section.Questions.map((question: any) => {
                    if (question.Type == 0) {
                        question.Options.unshift({ Id: null, Option: 'NA', Score: 0, isDefault: true });
                    }
                    return {
                        ...question,
                        selectedOption: question.Type == 0 ? question.Options[0] : null
                    };
                });
                return section;
            });

            if (this.isSavedRecord)
                this.getSavedQuestionList(this.cxtableService.editColumn?.row.CallSid);
        });
    };

    getApprovedQuestionList = (CallSid: string): void => {
        this.service.getSaveEvaluationDetails(CallSid).subscribe((data: any) => {
            this.evaluatorComment = data[0].EvaluatorComment;
            this.bonusPoints = data[0].BonusPoint;
            this.disputeComments = data[0].SupervisorComment || '';
            this.callBackComment = data[0].CallbackComment;
            this.isCallbackRequired = data[0].CallbackRequired;
            this.fileName = data[0].FileName,

                this.sections = data.map((section: any) => {
                    section.Questions = section.Questions.map((question: any) => {
                        return {
                            ...question,
                            Options:
                                question.Type == 0 && question.SelectedValue !== ""
                                    ? [{ Id: null, Option: question.SelectedValue, Score: question.Score }]
                                    : question.Type == 0 && question.SelectedValue === ""
                                        ? [{ Id: null, Option: 'NA', Score: 0 }]
                                        : question.Type == 2 && question.SelectedValue !== ""
                                            ? question?.SelectedValue : ''
                            ,
                            selectedOption: question.Type == 0 && question.SelectedValue !== ""
                                ? { Id: 0, Option: question.SelectedValue, Score: question.Score }
                                : question.Type == 0 && question.SelectedValue === ""
                                    ? { Id: null, Option: 'NA', Score: 0 }
                                    : question.Type == 2 && question.SelectedValue !== ""
                                        ? question?.SelectedValue : ''
                        };
                    });
                    return section;
                });
            this.Calculate();
        });
    };

    getSavedQuestionList = (CallSid: string): void => {
        this.service.getSaveEvaluationDetails(CallSid).subscribe((data: any) => {
            this.evaluatorComment = data[0].EvaluatorComment;
            this.bonusPoints = data[0].BonusPoint;
            this.disputeComments = data[0].SupervisorComment || '';
            this.callBackComment = data[0].CallbackComment;
            this.isCallbackRequired = data[0].CallbackRequired;
            this.fileName = data[0].FileName;

                this.sections = data.map((section: any, pi: any) => {
                    section.Questions = section.Questions.map((question: any, index: any) => {
                        const Q_Id = question.Type == 0 && question.SelectedValue !== "" ? this.sections[pi].Questions[index]?.Options.filter((opt: any) => opt?.Option === question?.SelectedValue)[0].Id : 0;
                        const Score = this.sections[pi].Questions[index]?.Score;
                        return {
                            Id: this.sections[pi].Questions[index].Id,
                            Options: this.sections[pi].Questions[index].Options,
                            Question: question.Question,
                            Score: Score,
                            Type: question.Type,
                            selectedOption: question.Type == 0 && question.SelectedValue !== ""
                                ? this.sections[pi].Questions[index]?.Options.filter((opt: any) => opt?.Option === question?.SelectedValue)[0]
                                : question.Type == 0 && question.SelectedValue === ""
                                    ? this.sections[pi].Questions[index].Options[0]
                                    : question.Type == 2 && question.SelectedValue !== ""
                                        ? question?.SelectedValue
                                        : ''
                        };
                    });

                    return section;
                });
            this.Calculate();
            if (this.fileName)
                this.isFileUploaded = true;
        });
    };
    fillAgentAndCallDetails(data: any) {
        let user = this.authService.authData;
        let duration;
        if ('Duration' in data)
            duration = data.Duration;
        else
            duration = data.CallDuration - data.WrapTime
        this.isSupervisor = user.AssignedApp.includes('Sightline');
        this.isAgent = user.AssignedApp.includes('ConnectHub');
        this.agentInformation.supervisor = user.ReportTo;
        this.agentInformation.location = user.Location;
        this.agentInformation.agent = data.PseudoName || data.AgentName || 'NA';
        this.agentInformation.client = data.CustomerFirstName || data.Customer|| 'NA';
        this.agentInformation.campaign = data.Skill;

        this.callInformation.callID = data.CallSid;
        this.callInformation.callDate = moment(data.CreatedOn).format('DD MMM YYYY HH:mm:ss a');
        this.callInformation.callTime = moment(data.CreatedOn).format('HH:mm');
        this.callInformation.callDuration = formatDate(duration);
        this.callInformation.wrapTime = data.Wrap || data.WrapTime || 0;
        this.callInformation.holdTime = data.Hold || 0;
        this.callInformation.tfn = data.TFN || 'NA';
        this.callInformation.callType = data.Type || 'NA';
        this.callInformation.disposition = data.Disposition || 'NA';
    }
    getQuestionScore(question: any) {
        return question.Type == 0
            ? question.selectedOption.Score
            : question.Type == 2 && question.selectedOption != null && question.selectedOption != ""
                ? question.Score
                : 0
    }
    updateScores(record: any) {
        if (!record.score)
            record.score = {};
        record.score.scoredSubtotal = this.calculateScoredSubtotal(record);
        record.score.subtotal = this.calculateSubtotal(record);
        record.score.sectionWeightage = this.calculateSectionWeightage(record);
    }

    calculatePossibleSubtotal(record: any) {
        return record.Questions.reduce((total: Number, question: any) => {
            if (this.isViewMode)
                return Number(question?.SelectedValue != '' ? question?.PossibleScore : 0) + Number(total);
            else {
                if (question?.selectedOption && question?.Type !== 2 && 'isDefault' in question.selectedOption)
                    return Number(total);
                else
                    return Number(question?.Score) + Number(total);
            }
        }, 0);
    }

    calculateScoredSubtotal(record: any) {
        return record.Questions.reduce((total: Number, question: any) => {
            if (this.isViewMode)
                return Number(question?.Score) + Number(total);
            else
                return Number(this.getQuestionScore(question) || 0) + Number(total);
        }, 0);
    }

    calculateSubtotal(record: any) {
        return this.calculateScoredSubtotal(record);
    }

    calculateSectionWeightage(record: any) {
        const scoredSubtotal = this.calculateScoredSubtotal(record);
        const possibleSubtotal = this.calculatePossibleSubtotal(record);
        if (possibleSubtotal === 0)
            return 0;
        const percentage = (scoredSubtotal / possibleSubtotal) * 100;
        return percentage;
    }

    Calculate() {
        this.resetCalculations();
        this.sections.forEach(section => {
            this.totalScoredPoints = this.totalScoredPoints + this.calculateScoredSubtotal(section);
            this.totalPossiblePoints = this.totalPossiblePoints + this.calculatePossibleSubtotal(section);
        });

        this.totalScoredPoints = this.totalScoredPoints;
        this.totalOverallScoredPoints = this.totalScoredPoints + Number(this.bonusPoints);
        this.overaAllPerc = (this.totalPossiblePoints === 0)
         ? '0.00'
         : ((this.totalOverallScoredPoints / this.totalPossiblePoints) * 100).toFixed(2);
        this.totalScoredPoints = this.totalScoredPoints.toFixed(2);
        this.totalPossiblePoints = this.totalPossiblePoints.toFixed(2);
        this.totalOverallScoredPoints = this.totalOverallScoredPoints.toFixed(2);
    }

    resetCalculations() {
        this.totalPossiblePoints = 0.00;
        this.overaAllPerc = 0.00;
        this.totalScoredPoints = 0.00;
    }

    collectFormData(SendForApproval: any) {
        const Questions = this.sections.map(section => ({
            Questions: section.Questions.map((question: any) => (
                {
                    QuestionId: question.Id,
                    Score: question.Score,
                    QuestionOptions: question.Type == 0
                        ? [{ OptionId: question.selectedOption.Id, Score: question.selectedOption.Score }]
                        : [],
                    Value: question.Type === 2 ? question.selectedOption || "" : null,
                    Type: question.Type
                }
            )).filter((mappedQuestion: any) => {
                return (
                    (
                        mappedQuestion.Type === 2
                        && mappedQuestion.Value !== ""
                        && mappedQuestion.Value !== null)
                    || mappedQuestion.QuestionOptions
                    && mappedQuestion.QuestionOptions[0]?.OptionId !== null
                )
            })
        }));

        const allQuestions = Questions.reduce((acc, section) => {
            return acc.concat(section.Questions);
        }, [])
        return {
            CallSid: this.callInformation?.callID,
            FileName: this.fileName,
            CallbackRequired: this.isCallbackRequired,
            CallType: this.callInformation?.callType || '',
            MonitoringType: this.callInformation?.disposition ||'',
            SendForApproval: SendForApproval,
            EvaluatorComment: this.evaluatorComment,
            CallbackComment: !this.isCallbackRequired ? '' : this.callBackComment,
            Questions: allQuestions,
            BonusPoint: this.bonusPoints,
        };
    }

    submitForm(SendForApproval: any) {
        if (this.fileName && !this.isFileUploaded)
            return this.toastService.warning('Please upload the selected file');
        const formData = this.collectFormData(SendForApproval);
        if (!this.hasAnyQuestionAnsered(formData.Questions))
            return this.toastService.warning('Please answer atleast one question');

        this.service.postEvaluationData(formData).subscribe((data: any) => {
            this.refreshService.triggerRefresh('Submit Form');
            setTimeout(() => {
                this.close.emit('');
            }, 1000);
        });
    };

    ApproveOrDisputeForm(status: any) {
        const formData = {
            IsAgent: this.isAgent,
            CallSid: this.cxtableService?.editColumn.row?.CallSid,
            Status: EvaluationFormStatus[status],
            Comment: EvaluationFormStatus[status] === 'Disputed' || EvaluationFormStatus[status] === 'Approved' || EvaluationFormStatus[status] === 'Coached' || EvaluationFormStatus[status] === 'Saved' ? this.disputeComments : this.evaluatorComment
        }
        this.service.updateEvaluationData(formData).subscribe((data: any) => {
            this.refreshService.triggerRefresh('Update Form Status');
            setTimeout(() => {
                this.close.emit('');
            }, 1000);
        });
    }

    onCommentInput(event: any, type: any) {
        let comment = '';
        if (event.target.value.length > this.maxCharacters)
            comment = event.target.value.substring(0, this.maxCharacters);
        else
            comment = event.target.value;

        if (type == 1)
            this.evaluatorComment = comment;
        else if (type == 2)
            this.disputeComments = comment;
        else
            this.callBackComment = comment;
    }

    get QAcharactersLeft(): number {
        return this.maxCharacters - this.evaluatorComment.length;
    }
    get SUPcharactersLeft(): number {
        return this.maxCharacters - this.disputeComments.length;
    }
    get CallbackRequiredcharactersLeft(): number {
        return this.maxCharacters - this.callBackComment.length;
    }
    onFileSelected(event: Event): void {
        let fileInput = event.target as HTMLInputElement;
        if (fileInput.files && fileInput.files.length > 0) {
            this.isFileUploaded = false
            const originalFile = fileInput.files[0];
            this.selectedFile = this.replaceFileName(originalFile, this.cxtableService.editColumn?.row.CallSid);
            this.fileName = this.selectedFile.name;
        }
    }
    onUpload(): void {
        if (!this.selectedFile)
            return;
        this.isUploading = true;
        const formData = new FormData();
        formData.append('file', this.selectedFile, this.selectedFile.name);
        formData.append('callSid', this.cxtableService.editColumn?.row.CallSid);
        this.service.uploadFile(formData).subscribe(
            (data: any) => {
                this.isUploading = false;
                this.isFileUploaded = true;
            },
            (error: any) => {
                console.error('Upload file failed', error);
                this.isUploading = false;
            });
    }
    onDownload(): void {
        if (this.fileName) {
            this.isDownloading = true;
            this.service.DownloadFile(this.fileName).subscribe(
                (response: any) => {
                    const blob = new Blob([response.body!], { type: response.headers.get('Content-Type')! });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = this.fileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    this.isDownloading = false;
                },
                (error) => {
                    this.isDownloading = false;
                    console.error('File download failed:', error);
                }
            );
        }
    }
    replaceFileName(file: File, newName: string): File {
        const lastDotIndex = file.name.lastIndexOf('.');
        const extension = lastDotIndex !== -1 ? file.name.slice(lastDotIndex) : '';
        const newFileName = newName + extension;
        return new File([file], newFileName, { type: file.type, lastModified: file.lastModified });
    }
    hasAnyQuestionAnsered(Questions: any) {
        return Questions?.some((q: any) => q.Type === 0);
    }
    onClose(e: MouseEvent) {
        e.preventDefault();
        this.close.emit('');
        this.refreshService.triggerTooltip();
    }

    ngOnDestroy(): void {
        this.close.emit('');
    }

}